import * as mod from "../../models/estadisticas.models";

import { Injectable } from "@angular/core";
import { BaseService } from "../baseService";
import { HttpClient } from "@angular/common/http";
import { Http } from "@angular/http";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable()
export class EstadisticasService extends BaseService {
    private readonly _NombreServicio: string = "actasEstadisticas/";

    // #region Propiedades del servicio
    private estadisticas: mod.ActasEstadisticas[];
    e$: BehaviorSubject<mod.ActasEstadisticas[]> = new BehaviorSubject<
        mod.ActasEstadisticas[]
    >(null);
    estadisticas$: Observable<mod.ActasEstadisticas[]> = this.e$.asObservable();
    // #endregion

    constructor(http: HttpClient, http2: Http) {
        super(http, http2);
    }

    // #region Métodos relacionados con el controlador API al que se hacen las llamadas.

    eliminar(urlBase: string, id: number): void {
        this.http.delete(this.UrlBase(urlBase) + 'eliminar/' + id.toString())
            .subscribe({
                next: () => {
                    this.estadisticas = this.estadisticas.filter(e => e.id !== id);
                    this.e$.next(this.estadisticas);
                },
                error: (error) => console.error(error)
            });
    }

    /**
     * Guarda una estadística.
     * @param estadisticas Estadística a guardar.
     */
    guardar(urlBase: string, estadisticas: mod.ActasEstadisticas): void {
        this.http.post(this.UrlBase(urlBase) + 'guardar', estadisticas)
            .subscribe({
                next: (resultado: mod.ActasEstadisticas) => {
                    if (resultado != null && resultado.id > 0) {
                        // Comprobar si existe en la lista
                        const index = this.estadisticas.findIndex(e => e.id === resultado.id);
                        if (index !== -1) {
                            // Actualizar
                            this.estadisticas[index] = resultado;
                        } else {
                            // Añadir
                            this.estadisticas.push(resultado);
                        }
                    }

                    this.e$.next(this.estadisticas);
                },
                error: (error) => console.error(error)
            });
    }

    /**
     * Obtiene las estadísticas de una designación.
     * @param idDesignacion Identificador de la designación.
     */
    listaPorDesignacion(urlBase: string, idDesignacion: number): void {
        this.http
            .get(
                this.UrlBase(urlBase) +
                    "listaPorDesignacion/" +
                    idDesignacion.toString()
            )
            .subscribe({
                next: (resultado: mod.ActasEstadisticas[]) => {
                    this.estadisticas = resultado;
                    this.e$.next(this.estadisticas);

                    console.log("Estadísticas", this.estadisticas);
                },
            });
    }

    /**
     * Comprueba si una estadística está establecida.
     * @param tipoEstadistica Tipo de estadística a comprobar.
     * @returns true si la estadística está establecida, false en caso contrario.
     */
    estadisticaEstablecida(tipoEstadistica: number): boolean {
        return this.estadisticas.some(m => m.tipoEstadistica == tipoEstadistica);
    }

    // #endregion

    // #region Métodos de control interno del servicio

    private UrlBase(url: string): string {
        return this.DireccionBase(url) + this._NombreServicio;
    }

    // #endregion
}



// WEBPACK FOOTER //
// ./src/services/api/estadisticas.service.ts